import { useMemo } from 'react';
import { useMutation } from '@apollo/client';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';

import { UPDATE_WORKSPACE_PROFILE } from '../../apis/workspace';
import useWorkspace from '../../context/WorkspaceContext';

const propTypes = {
  setValue: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.object]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setToast: PropTypes.func,
  setIsLoading: PropTypes.func,
};
const defaultProps = {
  setValue: '',
  data: {},
  value: '',
};

const UserTableRole = (props) => {
  // init
  const { value, setValue, setToast, data, setIsLoading } = props;
  const { userRoles, workspaceProfile } = useWorkspace();

  // mutations/queries
  const [updateWorkspaceProfile] = useMutation(UPDATE_WORKSPACE_PROFILE);

  const handleChange = async (e, roleId) => {
    if (data.type === 'user') {
      try {
        setIsLoading(true);
        await updateWorkspaceProfile({ variables: { input: { id: data.alldata.id, roleId } } });
        setValue(e.target.value);
        setToast((prevstate) => ({ ...prevstate, message: 'Role updated successfully!', open: true, type: 'success' }));
      } catch (error) {
        setToast((prevstate) => ({ ...prevstate, message: 'Something went wrong while updating role!', open: true, type: 'error' }));
      } finally {
        setIsLoading(false);
      }
    } else {
      setValue(e.target.value);
    }
  };

  const isRoleChangeAllowed = useMemo(() => {
    if (workspaceProfile.id === data.alldata.id) {
      return false;
    }

    if (workspaceProfile.roleId === 2 && data.alldata.roleId === 1) {
      return false;
    }

    return true;
  }, []);

  return (
    <span
      className="role-select-box"
      style={{ display: 'inline-block', verticalAlign: 'middle', lineHeight: '1' }}
    >
      <FormControl sx={{ minWidth: 130 }} size="small">
        <Select
          disabled={!isRoleChangeAllowed}
          IconComponent={ExpandMoreIcon}
          className="select-role"
          value={value || data.role}
          defaultValue={data.role}
          onChange={(e) => handleChange(e, userRoles.find((role) => role.value === e.target.value).id)}
          inputProps={{ 'aria-label': 'Without label' }}
        >
          {userRoles.map((role) => (
            <MenuItem value={role.value} key={role.id} className="select-item">
              {role.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </span>
  );
};
UserTableRole.propTypes = propTypes;
UserTableRole.defaultProps = defaultProps;
export default UserTableRole;
